import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';
import { showErrorNotification, showSuccessNotification } from '../shared/actions';

export function* getCategories(action) {
  try {
    const params = {
      query: {
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_CATEGORIES_BY_NAME, 'GET', params);

    yield put(actions.getCategoriesSuccess(data));
  } catch (e) {
    yield put(actions.getCategoriessError(e));
  }
}

export function* getCategoriesWatcher() {
  yield takeEvery(constants.GET_CATEGORIES, getCategories);
}

export function* getUserCategories() {
  try {
    const { data } = yield call(request, API.USER_CATEGORIES);

    yield put(actions.getUserCategoriesSuccess(data));
  } catch (e) {
    yield put(actions.getUserCategoriesError(e));
  }
}

export function* addUserCategory(action) {
  try {
    yield call(request, API.USER_CATEGORIES, 'PATCH', { query: { category_id: action.payload.id } });

    yield put(showSuccessNotification({ message: `Category "${action.payload.name}" successfully enabled.` }));
    yield put(actions.addUserCategorySuccess());
  } catch (e) {
    yield put(showErrorNotification({ message: `Oops :(\nWe could not enable category "${action.payload.name}".` }));
    yield put(actions.addUserCategoryError(e));
  } finally {
    yield put(actions.getUserCategories());
  }
}

export function* addUserCategoryWatcher() {
  yield takeEvery(constants.ADD_USER_CATEGORY, addUserCategory);
}

export function* removeUserCategory(action) {
  try {
    yield call(request, API.USER_CATEGORIES, 'DELETE', { query: { category_id: action.payload.id } });
    yield put(showSuccessNotification({ message: `Category "${action.payload.name}" successfully disabled.` }));
    yield put(actions.removeUserCategorySuccess());
  } catch (e) {
    yield put(showErrorNotification({ message: "Category can't be disabled because it is in use" }));
    yield put(actions.removeUserCategoryError(e));
  } finally {
    yield put(actions.getUserCategories());
  }
}

export function* removeUserCategoryWatcher() {
  yield takeEvery(constants.REMOVE_USER_CATEGORY, removeUserCategory);
}

export function* getUserCategoriesWatcher() {
  yield takeEvery([
    constants.GET_USER_CATEGORIES,
  ], getUserCategories);
}
